import { AxiosInstance } from "axios"

export interface AgentCountry {
  code: string
  name: string
}

/** Countries supported for Stripe Connect payout account creation.
 *  Returns a bare array — no `apiStatus`/`data` envelope. */
export function getAgentCountryListApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/agent/country/list",
  }) as Promise<{ data: AgentCountry[] }>
}
